import { Middleware } from 'redux';
import RootState from 'state/RootState';

const handler: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    next(action);
    const rootState = store.getState() as RootState;
    const { recorder } = rootState.app;
    const { isPlaying, motionSource, soundtrack } = rootState.flyer;
    // console.log(`PLAYING ${isPlaying}`);
    if (isPlaying) {
      if (recorder) {
        return;
      }
      motionSource.resume();
      soundtrack?.resume();
    } else {
      motionSource.pause();
      soundtrack?.pause();
    }
  };

export default handler;



// WEBPACK FOOTER //
// ./src/state/side-effects/motionSourcePlayback.ts